module.exports = "/lucky-balls/img/bigball/BigBall_012.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_012.png
// module id = 907
// module chunks = 0